import styled, { keyframes } from 'styled-components'

const InfoTitle = styled.div`
    width: 100%;
    padding: 4rem 2rem 2rem 2rem;
    color: #333;
    text-align: center;
    font-family: "sub-title-font";
    font-size: 3rem;
    display: flex;
    flex-direction: column;

`
const TypoTransform = keyframes`{
    0% {opacity: 0}
    45% {opacity: 0}
    55% {opacity: 1}
    100% {opacity: 1}
    }
`

const InfoEngligh = styled.div`
    position: relative;
    width: 100%;
    padding: 0rem 3rem 2rem 3rem;
    color: #888;
    text-align: left;
    font-family: "krean-font";
    font-size: 1.8rem;
`
const InfoKorean = styled.div`
    opacity: 0;
    background-color: #fff;
    top: 100px;
    position: absolute;
    animation: ${TypoTransform};
    animation-duration: 20s;
    animation-delay: 10s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    animation-direction: alternate-reverse;
    width: 100%;
    padding: 0rem 3rem 2rem 3rem;
    color: #888;
    text-align: left;
    font-family: "krean-font";
    font-size: 1.7rem;
`

const InfoEngligh02 = styled.div`
    position: relative;
    width: 100%;
    padding: 0rem 3rem 3rem 3rem;
    color: #888;
    text-align: center;
    font-family: "krean-font";
    font-size: 1.8rem;
`


const MailButton = styled.div`
    align-items: center;
    height: 8rem;

`

const MailLink = styled.a`
    padding-top: 0.3rem;
    position: relative;
    width:  8rem;
    height: 4rem;
    border: 2px solid #888;
    
    border-radius: 5rem;
    display: block;
    text-align: center;
    align-items: center;
    color: #888;
    text-decoration: none;
    font-size: 2.4rem;
    left: calc(50% - 4rem);

`

function InfoContents (){
    return <>
    <InfoTitle >Hi! I'm Youngbin! </InfoTitle>
    <InfoEngligh>We will do everything you need on your homepage as a service technician. From building a homepage with React to changing JQuery already running, I'm ready to tackle all the tough problems. Together, we will start to improve the quality of our service.</InfoEngligh>
    <InfoKorean>당신의 홈페이지에 필요한 모든 것을 서비스 기술자로서 함께할 것입니다. React를 통해 홈페이지를 구축하는 것부터 이미 운영 중인 JQuery를 변경하는 것까지, 모든 어려운 문제를 해결할 준비가 되어 있습니다. 우리가 함께함으로써 서비스 품질을 높이는데 시작이 될 것입니다.</InfoKorean>
    <InfoTitle >Contact</InfoTitle>
    <InfoEngligh02>Website Intergration | Website Build <br />Mobile-App Prototyping | UI Design</InfoEngligh02>
    <MailButton><MailLink href = "mailto:bolsalps@gmail.com?subject=Hi%20there!">email</MailLink></MailButton>
    </>
}

export default InfoContents